"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultPortalId;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

function defaultPortalId() {
  return _PortalIdParser.default.get();
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/lib/defaultPortalId.js
// module id = 863
// module chunks = 209 210 211 212